export class PageErrorEvent {
  event = 'page error';
}